module.exports = __webpack_public_path__ + "img/se.svg";